function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "XMLID_22_",
  d: "M244.229,148.625a1.846,1.846,0,1,0-1.855-1.846A1.853,1.853,0,0,0,244.229,148.625Zm0-2.722a.875.875,0,1,1-.884.875A.881.881,0,0,1,244.229,145.9Z",
  transform: "translate(-234.542 -140.24)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "XMLID_21_",
  d: "M16.93,2.371a1.6,1.6,0,0,0-.882-.958A18.59,18.59,0,0,0,8.741,0,18.591,18.591,0,0,0,1.434,1.413,1.6,1.6,0,0,0,.675,3.67L7.574,15.9a1.342,1.342,0,0,0,2.335,0l6.9-12.225A1.606,1.606,0,0,0,16.93,2.371ZM4.071,7.342A1.17,1.17,0,1,1,5.241,8.5a1.166,1.166,0,0,1-1.17-1.159Zm5.71,5.3a1.159,1.159,0,1,1,1.17-1.159A1.166,1.166,0,0,1,9.781,12.645Zm1.97-1.992a2.136,2.136,0,1,0-1.659,2.94l-1.03,1.825a.371.371,0,0,1-.643,0L5.06,9.464c.06,0,.12.008.181.008A2.13,2.13,0,1,0,3.326,6.391L2.577,5.063a13.8,13.8,0,0,1,6.164-1.37,13.8,13.8,0,0,1,6.164,1.37Zm4.21-7.46-.578,1.024A14.76,14.76,0,0,0,8.741,2.723,14.76,14.76,0,0,0,2.1,4.217L1.521,3.193a.63.63,0,0,1,.3-.889A17.614,17.614,0,0,1,8.741.971,17.614,17.614,0,0,1,15.663,2.3a.63.63,0,0,1,.3.889Z",
  transform: "translate(-0.469 0)",
  fill: "#fff"
});

function SvgPizza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pizza",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.545,
    height: 16.576,
    viewBox: "0 0 16.545 16.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.51ae3d27.svg";
export { ForwardRef as ReactComponent };